import {t} from 'i18next';
import {CarEditDto} from '../../../../../PRMGApiClient';

export interface SpecWithLabel {
  label: string;
  value: string;
}

export const getKeySpecificationsLabelList = (car?: CarEditDto): SpecWithLabel[] => [
  {
    label: t('Brand'),
    value: car?.main?.carMakeName ?? '-',
  },
  {
    label: t('Model'),
    value: car?.main?.carModelName ?? '-',
  },
  {
    label: t('Plate No'),
    value: car?.main?.plateNumber ?? '-',
  },
  {
    label: t('VIN'),
    value: car?.main?.vin ?? '-',
  },
  {
    label: t('Production year'),
    value: car?.main?.manufactureYear?.toString() ?? '-',
  },
  {
    label: t('First registration date'),
    value:
      car?.main?.firstRegistration?.toLocaleString('en', {month: '2-digit', day: '2-digit', year: 'numeric'}) ?? '-',
  },
  {
    label: t('Mileage'),
    value: car?.main?.currentMileage?.toString() ?? '-',
  },
  {
    label: t('Value'),
    value: car?.main?.currentWorth?.toString() ?? '-',
  },
  {
    label: t('Color'),
    value: car?.main?.calendarColorRGB?.toString() ?? '-',
  },
  {
    label: t('State'),
    value: car?.main?.status?.toString() ?? '-',
  },
  {
    label: t('Remarks'),
    value: car?.main?.remarks?.toString() ?? '-',
  },
];

export const getServiceDataLabelList = (car?: CarEditDto): SpecWithLabel[] => [
  {
    label: t('Body type'),
    value: car?.service?.bodyType ?? '-',
  },
  {
    label: t('Fuel type'),
    value: car?.service?.fuel ?? '-',
  },
  {
    label: t('Engine oil'),
    value: car?.service?.engineOil ?? '-',
  },
  {
    label: t('Drive type'),
    value: car?.service?.drive ?? '-',
  },
  {
    label: t('Transmission type'),
    value: car?.service?.gear ?? '-',
  },
  {
    label: t('Paint color'),
    value: car?.service?.bodyColorId?.toString() ?? '-',
  },
  {
    label: t('Paint code'),
    value: car?.service?.bodyColorMakeCode ?? '-',
  },
  {
    label: t('Paint type'),
    value: car?.service?.paintEffect ?? '-',
  },
  {
    label: t('Protection'),
    value: car?.service?.paintProtection ?? '-',
  },
];
